module.exports = __webpack_public_path__ + "media/images/architect-bg-1-e1c45b98cc33cd0b5a6d90bc809d5e3a.jpg";